import { withTheme } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { useOperationState } from "../../../../hooks/operationsState";
import { operationPath, selectQRCode } from "../../store";

function QRCode() {
  const qrCode = useSelector(selectQRCode);
  const { operationLoading } = useOperationState(operationPath.qrCode, {
    defaultLoading: true,
  });

  return (
    <StyledWrapper>
      {!qrCode || operationLoading ? (
        <StyledSkeleton width={240} height={241} />
      ) : (
        <img
          src={`data:image/svg+xml;base64,${qrCode}`}
          width={240}
          height={241}
          alt="qr"
          data-testid="user-settings-twofa-enable-qrcode"
        />
      )}
    </StyledWrapper>
  );
}

export default QRCode;

const StyledWrapper = withTheme(styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => `${theme.spacing(3)}px`};
`);

const StyledSkeleton = styled(Skeleton)`
  transform: none;
`;
